module.exports = __webpack_public_path__ + "img/list_img_empty.fdbace64.png";